export default __webpack_public_path__ + "static/media/logo.e401dae4.png";